import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import { TalentService, TagService, 
  type TalentRetrieveData, type TalentSearchCreateData, 
  type TalentUpdateData, type TalentDeleteCreateData, type TalentStatisticsRetrieveData,
  type TalentUpdateInfoCreateData, type TalentGetListNewListData,
  type TalentApproveRetrieveData, type TalentResendApproveEmailRetrieveData, 
  type TagTalentTagListUpdateData, type TalentJobRecommendRetrieveData,
  type TalentReferrerTalentRetrieveData, type TalentCancelTalentCreateData, type TagTalentTagListListData, 
  type TalentNewsRecommendRetrieveData, type TagTalentTagOptionsListData,
  type TalentUpdateResumeCreateData, type TalentCancelApproveRetrieveData
} from "api";
import i18n from 'i18next';
import { updatePaginatedList } from "../utils/util";
import { resetAppState } from "../store/common";

// Get talent statistics
export const getStatistics = createAsyncThunk(
  "getStatistics",
  async (data: TalentStatisticsRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentStatisticsRetrieve(data) as any;
      return res && res.data ? res.data : thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Search talents
export const searchTalent = createAsyncThunk(
  "searchTalent",
  async (data: TalentSearchCreateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentAdvancedSearchCreate(data) as any;
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Get detail talent
export const getDetailTalent = createAsyncThunk(
  "getDetailTalent",
  async (data: TalentRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentRetrieve(data) as any;
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Get options related talent
export const getOptionsRelatedTalent = createAsyncThunk(
  "getOptionsRelatedTalent",
  async (_, thunkAPI: any) => {
    try {
      const res = await TalentService.talentGetOptionsRelatedRetrieve() as any;
      if (res && res.data) {
        return res.data;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Get
export const getListNewTalent = createAsyncThunk(
  "getListNewTalent",
  async (data: TalentGetListNewListData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentGetListNewList(data) as any;
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Update talent
export const updateTalent = createAsyncThunk(
  "updateTalent",
  async (data: TalentUpdateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentUpdate(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const deleteTalent = createAsyncThunk(
  "deleteTalent",
  async (data: TalentDeleteCreateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentDeleteCreate(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Update recruitment rank of talent
export const updateTalentInfo = createAsyncThunk(
  "updateTalentInfo",
  async (data: TalentUpdateInfoCreateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentUpdateInfoCreate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Update recruitment rank of talent
export const updateTalentResume = createAsyncThunk(
  "updateTalentResume",
  async (data: TalentUpdateResumeCreateData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentUpdateResumeCreate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Approve talent
export const approveTalent = createAsyncThunk(
  "approveTalent",
  async (data: TalentApproveRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentApproveRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Cancel talent's approval
export const cancelTalentApproval = createAsyncThunk(
  "cancelTalentApproval",
  async (data: TalentCancelApproveRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentCancelApproveRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Resend email approve talent
export const resendEmailApproveTalent = createAsyncThunk(
  "resendEmailApproveTalent",
  async (data: TalentResendApproveEmailRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentResendApproveEmailRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Approve talent bulk
export const approveTalentBulk = createAsyncThunk(
  "approveTalentBulk",
  async (data: any, thunkAPI: any) => {
    try {
      const res = await TalentService.talentApproveBulkCreate(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Cancel approve talent bulk
export const cancelApproveTalentBulk = createAsyncThunk(
  "cancelApproveTalentBulk",
  async (_, thunkAPI: any) => {
    try {
      const res = await TalentService.talentCancelApproveBulkCreate();
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Search job view recommend
export const searchJobViewRecommend = createAsyncThunk(
  "searchJobViewRecommend",
  async (data: TalentJobRecommendRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentJobRecommendRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Search news view recommend
export const searchNewsViewRecommend = createAsyncThunk(
  "searchNewsViewRecommend",
  async (data: TalentNewsRecommendRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentNewsRecommendRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Search referrer talent
export const searchReferrerTalent = createAsyncThunk(
  "searchReferrerTalent",
  async (data: TalentReferrerTalentRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentReferrerTalentRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

// Search job scout recommend
export const searchJobScoutRecommend = createAsyncThunk(
  "searchJobScoutRecommend",
  async (data: TalentJobRecommendRetrieveData, thunkAPI: any) => {
    try {
      const res = await TalentService.talentJobRecommendRetrieve(data);
      if (res) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getTalentTagsPanel = createAsyncThunk(
  "getTalentTagsPanel",
  async (data: TagTalentTagListListData, thunkAPI: any) => {
    try {
      const res: any = await TagService.tagTalentTagListList(data);
      if (res.results.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const updateSelectedTalentTagsPanel = createAsyncThunk(
  "updateSelectedTalentTagsPanel",
  async (data: TagTalentTagListUpdateData, thunkAPI: any) => {
    try {
      const res: any = await TagService.tagTalentTagListUpdate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getTalentTagOptions = createAsyncThunk(
  "getTalentTagOptions",
  async (data: TagTalentTagOptionsListData, thunkAPI: any) => {
    try {
      const res: any = await TagService.tagTalentTagOptionsList(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const cancelTalent = createAsyncThunk(
  "cancelTalent",
  async (data: TalentCancelTalentCreateData, thunkAPI: any) => {
    try {
      const res: any = await TalentService.talentCancelTalentCreate(data);
      if (res) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const importTalent = createAsyncThunk(
  "importTalent",
  async (data: TalentImportCreateData, thunkAPI: any) => {
    try {
      const res: any = await TalentService.talentImportCreate(data);
      if (res.success) {
        return res;
      } else {
        return thunkAPI.rejectWithValue({
          message: res.message || i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'),
          data: res.data || [],
        });
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const savingImportTalent = createAsyncThunk(
  "savingImportTalent",
  async (data: TalentSaveImportCreateData, thunkAPI: any) => {
    try {
      const res: any = await TalentService.talentSaveImportCreate(data);
      if (res.success) {
        return res;
      } else {
        return thunkAPI.rejectWithValue({
          message: res.message || i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'),
          data: res.data || [],
        });
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

const initTalentRegTableHeaders = [
  { title: "氏名", isSort: false, maxWidth: 112 },
  { title: "メールアドレス", isSort: false, maxWidth: 240 },
  { title: "アクション", isSort: false, width: 112 },
  { title: "状況", isSort: false, width: 90 },
  { title: "性別", isSort: false, width: 54 },
  { title: "年齢", isSort: false, width: 54 },
  { title: "社員番号", isSort: false, width: 106 },
  { title: "居住地", isSort: false, width: 80 },
  { title: "登録経路", isSort: true, width: 68, field: "register_channel", currentSortState: 0, },
  { title: "種別", isSort: false, maxWidth: 90 },
  { title: "最終更新日時", isSort: true, maxWidth: 178, field: "updated_at", currentSortState: 2, }
];

const sortingStates = [ "default", "asc", "desc"];

interface CompanyTalent { 
  id: number; 
  name: string; 
  department: string; 
  actions: Array<{ name: string; action: (talent: CompanyTalent) => void }>;
}
// State ban đầu của Redux
interface TalentState { talentList: CompanyTalent[]; talentCount: number; talentNewCount: number;
  currentPage: number; currentPageNewList: number; pageSize: number; totalPage: number; talentStatistics: any;
  talentOptionsRelatedData: any; loading: boolean; loadingFetchTalent: boolean; error: string | null; isPanelDetailTalentOpen: boolean;
  selectedTalent: CompanyTalent | {}; sortBy: string; sortOrder: string; isOnConfirmDelete: boolean;
  deleteId: number; filterQuery: any; talentNewList: CompanyTalent[];
  fileLoaded: boolean; resultImport: any; listImportSuccess: any[]; listImportError: any[]; currentPageSuccess: number; currentPageError: number; importPageSize: number; errorLoaded: boolean;
  file: any; actionStatus: string; actionName: string; message: string; isSuccess: boolean;
  isOpenRegisterPanel: boolean; isEditing: boolean; isLoadingAddUpdate: boolean; isLoadingDelete: boolean;
  isLoadingSendMail: boolean; isLoadingImport: boolean;
  selectedRows: any[]; displaySelectedCount: number;
  talentSearchForm: any;
  genderOptions: any;
  professionOptions: any; 
  cityOptions: any; 
  typeOptions: any; 
  changeJobOptions: any; 
  statusOptions: any;
  recruitmentRankOptions: any;
  ageRankOptions: any;
  scoutHistoryOptions: any;
  activityLevelOptions: any;
  loginTimeOptions: any;
  viewJobTimeOptions: any;
  expectedConditionOptions: any;
  workingStyleOptions: any;
  resignationReasonOptions: any;
  newsViewRecommendOptions: any;
  talentSelectedSchedule: any;
  haveOtherConditionSearch: boolean;
  viewedJobTitle: string;
  scoutJobTitle: string;
  globalTalentStatus: any;
  globalTalentStatusDateRank: any;
  isClickSearch: boolean;
  talentTagsList: any;
  talentTagsSelected: any;
  hasMore: boolean,
  currentPageTagsList: number,
  pageSizeTagsList: number,
  talentTagOptions: any,
  initSearchTalentForm: any,
  searchTagResult: any,
  searchQuery: string | null,
  cancelTalentStatus: string | null,
  jobType1Options: any,
  jobType2Options: any,
  jobType3Options: any,
  industry1Options: any,
  industry2Options: any,
  industry3Options: any,
  pageSizeTalentRegister: number,
  registerChannelFilter: string | null,
  filterStatus: boolean,
  resumeLinks: any,
  approvingStatus: boolean,
  approveBulkAbortController: AbortController | null,
  fetchTalentNewListLoading: boolean,
  talentRegTableHeaders: any[],
  newListSortBy: string | null,
  newListSortOrder: string | null
}

const initialState: TalentState = { talentList: [], talentCount: 10, talentNewCount: 1, currentPage: 1,
  currentPageNewList: 1, pageSize: 100, totalPage: 1, talentStatistics: {}, selectedTalent: {},
  talentOptionsRelatedData: { talent_types: [], talent_status: [], recruitment_ranks: [] },
  loading: false, loadingFetchTalent: false, error: null, isPanelDetailTalentOpen: false, sortBy: '-talent_last_access', sortOrder: "desc",
  isOnConfirmDelete: false, deleteId: 0, filterQuery: null, talentNewList: [],
  fileLoaded: false, resultImport: {}, listImportSuccess: [], listImportError: [], currentPageSuccess: 1, currentPageError: 1, importPageSize: 10, errorLoaded: false,
  file: null, actionStatus: "idle", actionName: "", message: "", isSuccess: true, isOpenRegisterPanel: false,
  isEditing: true, isLoadingAddUpdate: false, isLoadingDelete: false, isLoadingSendMail: false,
  selectedRows: [], displaySelectedCount: 0,
  isLoadingImport: false,
  talentSearchForm: {},
  genderOptions: [],
  professionOptions: [],
  cityOptions: [],
  preferredCityOptions: [],
  typeOptions: [],
  changeJobOptions: [],
  statusOptions: [],
  dateOptions: [],
  jobViewRecommendOptions: [],
  jobScoutRecommendOptions: [],
  recruitmentRankOptions: [],
  talentSelectedSchedule: [],
  haveOtherConditionSearch: false,
  viewedJobTitle: '',
  scoutJobTitle: '',
  globalTalentStatus: {},
  globalTalentStatusDateRank: { name: "過去30日間", id: 'day_30' },
  isClickSearch: false,
  initSearchTalentForm: {
    name: '',
    email: '',
    age_from: '',
    age_to: '',
    gender: null,
    date_of_birth_start: null,
    date_of_birth_end: null,
    type: null,
    work_parttime: null,
    change_job: null,
    status: null,
    status_date_rank: null,
    activity_level: null,
    job_view_level: null,
    access_time: null,
    recruitment_rank: null,
    city: null,
    scout_history: null,
    created_at_start: null,
    created_at_end: null,
    viewed_job_id: null,
    scout_job_id: null,
    tags: null,
    tag_condition: {name: 'すべて含む', id: 'and'},
    register_code: '',
    referrerTalentOptions: [],
    searchQuery: '',
    profession_1_id: null,
    profession_2_id: null,
    profession_3_id: null,
    industry_1_id: null,
    industry_2_id: null,
    industry_3_id: null,
    expected_condition: null,
    preferred_city_id: null,
    working_style_id: null,
    is_referred: null,
    referrer_talent: '',
    department: '',
    date_join_company_start: null,
    date_join_company_end: null,
    date_leave_company_start: null,
    date_leave_company_end: null,
    reason_resignation: null,
    last_job_viewed_time: null,
    viewed_new_id: null,
    agent_info: '',
    ownership_period_start_date_start: null,
    ownership_period_start_date_end: null,
    ownership_period_end_date_start: null,
    ownership_period_end_date_end: null,
    withdrawn_talent_included: null
  },
  globalSearchTalentFormData: null,
  ageRankOptions: [
    { name: '20~29歳', id: '20-29' },
    { name: '30~39歳', id: '30-39' },
    { name: '40~49歳', id: '40-49' }
  ],
  scoutHistoryOptions: [
    { name: '送信済', id: 'yes' },
    { name: '未送信', id: 'no' }
  ],
  activityLevelOptions: [
    { name: '高', id: 'high' },
    { name: '中', id: 'medium' },
    { name: '低', id: 'low' }
  ],
  loginTimeOptions: [],
  viewJobTimeOptions: [],
  expectedConditionOptions: [],
  workingStyleOptions: [],
  jobType1Options: [],
  jobType2Options: [],
  jobType3Options: [],
  industry1Options: [],
  industry2Options: [],
  industry3Options: [],
  resignationReasonOptions: [],
  newsViewRecommendOptions: [],
  talentTagsList: [],
  talentTagsSelected: [],
  hasMore: false,
  currentPageTagsList: 1,
  pageSizeTagsList: 15,
  talentTagOptions: null,
  searchTagResult: null,
  cancelTalentStatus: "idle",
  pageSizeTalentRegister: 100,
  registerChannelFilter: null,
  filterStatus: false,
  resumeLinks: [],
  approvingStatus: false,
  approveBulkAbortController: null,
  fetchTalentNewListLoading: false,
  talentRegTableHeaders: initTalentRegTableHeaders,
  newListSortBy: "updated_at",
  newListSortOrder: "desc"
};
// Create slice, reducers and extraReducers
export const companyTalentSlice = createSlice({
  name: "companyTalent",
  initialState,
  reducers: {
    setIsPanelDetailTalentOpen(state, action) { state.isPanelDetailTalentOpen = action.payload; },
    setSelectedTalent(state, action) { state.selectedTalent = action.payload; },
    setEditingTalent(state, action) {state.isEditing = action.payload; },
    clearSelectedTalent(state) { state.selectedTalent = {}; },
    setSortBy: (state, action) => { state.sortBy = action.payload; },
    setSortOrder: (state, action) => { state.sortOrder = action.payload; },
    setCurrentPage: (state, action) => { state.currentPage = action.payload; },
    setCurrentPageNewList: (state, action) => { state.currentPageNewList = action.payload; },
    setOnConfirmDelete: (state, action) => {
      state.isOnConfirmDelete = action.payload;
      if (!action.payload) state.deleteId = 0;
    },
    setDeleteId: (state, action) => { state.deleteId = action.payload; },
    setFilterQuery: (state, action) => { state.filterQuery = action.payload; },
    setCancelImport: (state) => { state.fileLoaded = false;
      state.resultImport = {}; state.listImportSuccess = []; state.listImportError = [];
      state.currentPageSuccess = 1; state.currentPageError = 1;
      state.errorLoaded = false; state.file = null; },
    setFile: (state, action) => { state.file = action.payload; },
    setResultImport: (state, action) => { state.resultImport = action.payload; },
    setListImportError: (state, action) => { state.listImportError = action.payload; },
    setListImportSuccess: (state, action) => { state.listImportSuccess = action.payload; },
    setCurrentPageSuccess: (state, action) => { state.currentPageSuccess = action.payload; },
    setCurrentPageError: (state, action) => { state.currentPageError = action.payload; },
    setImportPageSize: (state, action) => { state.importPageSize = action.payload; },
    setActionStatus: (state, action) => { state.actionStatus = action.payload; },
    setIsOpenRegisterPanel: (state, action) => { state.isOpenRegisterPanel = action.payload; },
    setIsLoadingAddUpdate: (state, action) => { state.isLoadingAddUpdate = action.payload; },
    setIsLoadingImport: (state, action) => { state.isLoadingImport = action.payload; },
    setIsLoadingDelete: (state, action) => { state.isLoadingDelete = action.payload; },
    setIsLoadingSendMail: (state, action) => { state.isLoadingSendMail = action.payload; },
    setLoadingFetchTalent: (state, action) => { state.loadingFetchTalent = action.payload; },
    setTalentSearchForm: (state, action) => { state.talentSearchForm = action.payload; },
    setGenderOptions: (state, action) => { state.genderOptions = action.payload; },
    setProfessionOptions: (state, action) => { state.professionOptions = action.payload; },
    setCityOptions: (state, action) => { state.cityOptions = action.payload; },
    setPreferredCityOptions: (state, action) => { state.preferredCityOptions = action.payload; },
    setTypeOptions: (state, action) => { state.typeOptions = action.payload; },
    setChangeJobOptions: (state, action) => { state.changeJobOptions = action.payload; },
    setStatusOptions: (state, action) => { state.statusOptions = action.payload; },
    setDateOptions: (state, action) => { state.dateOptions = action.payload; },
    setRecruitmentRankOptions: (state, action) => { state.recruitmentRankOptions = action.payload; },
    setJobViewRecommendOptions: (state, action) => { state.jobViewRecommendOptions = action.payload; },
    setJobScoutRecommendOptions: (state, action) => { state.jobScoutRecommendOptions = action.payload; },
    setViewedJobTitle: (state, action) => { state.viewedJobTitle = action.payload; },
    setScoutJobTitle: (state, action) => { state.scoutJobTitle = action.payload; },
    setGlobalTalentStatus: (state, action) => { state.globalTalentStatus = action.payload; },
    setGlobalTalentStatusDateRank: (state, action) => { state.globalTalentStatusDateRank = action.payload; },
    setHaveOtherConditionSearch: (state, action) => { state.haveOtherConditionSearch = action.payload; },
    setGlobalSearchTalentFormData: (state, action) => { state.globalSearchTalentFormData = action.payload; },
    setIsClickSearch: (state, action) => { state.isClickSearch = action.payload; },
    setTalentTagsList: (state, action) => { state.talentTagsList = action.payload; },
    setCurrentPageTagsList: (state, action) => { state.currentPageTagsList = action.payload; },
    setInitSearchTalentForm: (state, action) => { state.initSearchTalentForm = action.payload; },
    setSearchTagResult: (state, action) => { state.searchTagResult = action.payload; },
    setReferrerTalentOptions: (state, action) => { state.referrerTalentOptions = action.payload; },
    setSearchQuery: (state, action) => { state.searchQuery = action.payload; },
    setCancelTalentStatus(state, action) { state.cancelTalentStatus = action.payload; },
    setLoginTimeOptions(state, action) { state.loginTimeOptions = action.payload; },
    setViewJobTimeOptions(state, action) { state.viewJobTimeOptions = action.payload; },
    setExpectedConditionOptions(state, action) { state.expectedConditionOptions = action.payload; },
    setWorkingStyleOptions(state, action) { state.workingStyleOptions = action.payload; },
    setResignationReasonOptions(state, action) { state.resignationReasonOptions = action.payload; },
    setJobType1Options(state, action) { state.jobType1Options = action.payload; },
    setJobType2Options(state, action) { state.jobType2Options = action.payload; },
    setJobType3Options(state, action) { state.jobType3Options = action.payload; },
    setIndustry1Options(state, action) { state.industry1Options = action.payload; },
    setIndustry2Options(state, action) { state.industry2Options = action.payload; },
    setIndustry3Options(state, action) { state.industry3Options = action.payload; },
    setTalentListPageSize(state, action) { state.pageSize = action.payload; },
    setSelectedRows(state, action) { state.selectedRows = action.payload; },
    setDisplaySelectedCount(state, action) { state.displaySelectedCount = action.payload; },
    setTalentTagsSelected(state, action) { state.talentTagsSelected = action.payload; },
    setTalentRegisterPageSize(state, action) { state.pageSizeTalentRegister = action.payload; },
    setRegisterChannelFilter(state, action) { state.registerChannelFilter = action.payload; },
    setFilterStatus(state, action) { state.filterStatus = action.payload; },
    setLoading(state, action) { state.loading = action.payload; },
    setApprovingStatus(state, action) { state.approvingStatus = action.payload; },
    setApproveBulkAbortController(state, action) { state.approveBulkAbortController = action.payload; },
    resetBulkApproveState(state) {
      state.approvingStatus = false;
      state.approveBulkAbortController = null;
    },
    resetActionState(state) {
      state.actionStatus = "idle";
      state.actionName = "";
      state.message = "";
    },
    handleSortByHeader(state, action) {
      const sortHeader = action.payload;
      state.talentRegTableHeaders = state.talentRegTableHeaders.map((header, idx) => (header.field === sortHeader.field)
      ? ({...header, currentSortState: (header.currentSortState + 1) % sortingStates.length})
      : ({...header, currentSortState: 0}));
      
      if((sortHeader.currentSortState + 1) % sortingStates.length !== 0) {
          state.newListSortBy = sortHeader.field;
          state.newListSortOrder = sortingStates[(sortHeader.currentSortState + 1) % sortingStates.length];
      } else {
          state.newListSortBy = null;
          state.newListSortOrder = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // reset state
      .addCase(resetAppState, () => initialState)

      // Search talents
      .addCase(searchTalent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "searchTalent";
        state.actionStatus = "pending";
        state.loadingFetchTalent = true;
      })
      .addCase(searchTalent.fulfilled, (state, action) => {
        state.loading = false;
        state.talentList = action.payload?.data?.talents ? action.payload?.data?.talents : [];
        state.talentCount = action.payload?.data?.total_rows;
        state.totalPage = Math.ceil(state.talentCount / state.pageSize);
        state.actionName = "searchTalent";
        state.actionStatus = "fulfilled";
        state.loadingFetchTalent = false;
      })
      .addCase(searchTalent.rejected, (state, action) => {
        state.loading = false;
        state.loadingFetchTalent = false;
        state.error = action.payload as string;
        state.actionName = "searchTalent";
        state.actionStatus = "rejected";
      })
      // Get statistics
      .addCase(getStatistics.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "statistics"; state.actionStatus = "pending"; })
      .addCase(getStatistics.fulfilled, (state, action) => {
        state.loading = false; state.talentStatistics = action.payload;
        state.actionName = "statistics"; state.actionStatus = "fulfilled"; })
      .addCase(getStatistics.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "statistics"; state.actionStatus = "rejected"; })
      // Get detail talent
      .addCase(getDetailTalent.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "detail"; state.actionStatus = "pending"; })
      .addCase(getDetailTalent.fulfilled, (state, action) => {
        state.loading = false; state.selectedTalent = action.payload;
        state.actionName = "detail"; state.actionStatus = "fulfilled"; })
      .addCase(getDetailTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "detail"; state.actionStatus = "rejected"; })
      // Get options related talent
      .addCase(getOptionsRelatedTalent.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "option"; state.actionStatus = "pending"; })
      .addCase(getOptionsRelatedTalent.fulfilled, (state, action) => {
        state.loading = false; state.talentOptionsRelatedData = action.payload;
        state.actionName = "option"; state.actionStatus = "fulfilled"; })
      .addCase(getOptionsRelatedTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "option"; state.actionStatus = "rejected"; })
      // Get list new talents
      .addCase(getListNewTalent.pending, (state) => {
        state.fetchTalentNewListLoading = true;
        state.loading = true; state.error = null;
        state.actionName = "listNew"; state.actionStatus = "pending"; })
      .addCase(getListNewTalent.fulfilled, (state, action) => {
        state.fetchTalentNewListLoading = false;
        state.loading = false; state.talentNewList = action.payload.results ? action.payload.results : [];
        state.talentNewCount = action.payload.count;
        state.actionName = "listNew"; state.actionStatus = "fulfilled"; })
      .addCase(getListNewTalent.rejected, (state, action) => {
        state.fetchTalentNewListLoading = false;
        state.loading = false; state.error = action.payload as string;
        state.actionName = "listNew"; state.actionStatus = "rejected"; })
      // Update talent
      .addCase(updateTalent.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionStatus = "pending";})
      .addCase(updateTalent.fulfilled, (state, action) => {
        state.loading = false; state.actionStatus = "fulfilled";
        state.message = action.payload.message; state.isSuccess = action.payload.success; 
        state.actionName = "update"; 
        if(action.payload.success) {
          state.isOpenRegisterPanel = false;
          state.selectedTalent = action.payload.data;
          state.isEditing = false; 
        }
      })
      .addCase(updateTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionStatus = "rejected";})
      // Delete talent
      .addCase(deleteTalent.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending"; })
      .addCase(deleteTalent.fulfilled, (state, action) => {
        state.loading = false; state.selectedTalent = action.payload.data; state.message = action.payload.message;
        state.isSuccess = action.payload.success; state.actionStatus = "fulfilled"; state.actionName = "delete"; })
      .addCase(deleteTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string; state.actionStatus = "rejected"; })

      // Update recruitment rank of talent
      .addCase(updateTalentInfo.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending"; })
      .addCase(updateTalentInfo.fulfilled, (state, action) => {
        state.loading = false; state.message = action.payload.message;
        state.actionStatus = "fulfilled"; state.actionName = "updateTalentInfo";
        state.isSuccess = action.payload.success; })
      .addCase(updateTalentInfo.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionStatus = "rejected"; })

      // Update talent resume
      .addCase(updateTalentResume.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending"; })
      .addCase(updateTalentResume.fulfilled, (state, action) => {
        state.loading = false; state.message = action.payload.message;
        state.resumeLinks = action.payload.data;
        state.actionStatus = "fulfilled"; state.actionName = "updateTalentResume";
        state.isSuccess = action.payload.success; })
      .addCase(updateTalentResume.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionStatus = "rejected"; })

      // Approve talent
      .addCase(approveTalent.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending"; })
      .addCase(approveTalent.fulfilled, (state, action: any) => {
        state.loading = false; state.actionName = "approveTalent"; state.actionStatus = "fulfilled";
        state.message = action.payload.message; state.isSuccess = action.payload.success;
        if (action.payload?.success) {
          const targetId = action.meta.arg.id;
          const newStatus = action.payload?.status || "approving";
          state.talentNewList = state.talentNewList.map((item: any) =>
            item.id === targetId ? { ...item, status: newStatus } : item
          );
        }
      })
      .addCase(approveTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string; state.actionStatus = "rejected"; })
      // Cancel talent's approval
      .addCase(cancelTalentApproval.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending"; })
      .addCase(cancelTalentApproval.fulfilled, (state, action: any) => {
        state.loading = false; state.actionName = "cancelTalentApproval"; state.actionStatus = "fulfilled";
        state.message = action.payload.message; state.isSuccess = action.payload.success;
        if (action.payload?.success) {
          const targetId = action.meta.arg.id;
          state.talentNewList = state.talentNewList.map((item: any) =>
            item.id === targetId ? { ...item, status: "new" } : item
          );
        }
      })
      .addCase(cancelTalentApproval.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string; state.actionStatus = "rejected"; })
        
      // Resend email approve talent
      .addCase(resendEmailApproveTalent.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending"; })
      .addCase(resendEmailApproveTalent.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "resendEmailApproveTalent"; state.actionStatus = "fulfilled";
        state.message = action.payload.message; state.isSuccess = action.payload.success; })
      .addCase(resendEmailApproveTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string; state.actionStatus = "rejected"; })

      // Search job view recommend
      .addCase(searchJobViewRecommend.pending, (state) => {
        state.loading = true; 
        state.error = null; 
        state.actionStatus = "pending"; 
      })
      .addCase(searchJobViewRecommend.fulfilled, (state, action) => {
        state.loading = false; 
        state.actionName = "searchJobViewRecommend"; 
        state.actionStatus = "fulfilled";
        state.jobViewRecommendOptions = action.payload.data;
      })
      .addCase(searchJobViewRecommend.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload as string; 
        state.actionStatus = "rejected"; 
      })

      // Search news view recommend
      .addCase(searchNewsViewRecommend.pending, (state) => {
        state.loading = true; 
        state.error = null; 
        state.actionStatus = "pending"; 
      })
      .addCase(searchNewsViewRecommend.fulfilled, (state, action) => {
        state.loading = false; 
        state.actionName = "searchNewsViewRecommend"; 
        state.actionStatus = "fulfilled";
        state.newsViewRecommendOptions = action.payload.data;
      })
      .addCase(searchNewsViewRecommend.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload as string; 
        state.actionStatus = "rejected"; 
      })

      // Search referrer talent
      .addCase(searchReferrerTalent.pending, (state) => {
        state.loading = true; 
        state.error = null; 
        state.actionStatus = "pending"; 
      })
      .addCase(searchReferrerTalent.fulfilled, (state, action) => {
        state.loading = false; 
        state.actionName = "searchReferrerTalent"; 
        state.actionStatus = "fulfilled";
        state.referrerTalentOptions = action.payload.data;
      })
      .addCase(searchReferrerTalent.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload as string; 
        state.actionStatus = "rejected"; 
      })

      // Search job scout recommend
      .addCase(searchJobScoutRecommend.pending, (state) => {
        state.loading = true; 
        state.error = null; 
        state.actionStatus = "pending"; 
      })
      .addCase(searchJobScoutRecommend.fulfilled, (state, action) => {
        state.loading = false; 
        state.actionName = "searchJobScoutRecommend"; 
        state.actionStatus = "fulfilled";
        state.jobScoutRecommendOptions = action.payload.data;
      })
      .addCase(searchJobScoutRecommend.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload as string; 
        state.actionStatus = "rejected"; 
      })

      // getTalentTagsPanel
      .addCase(getTalentTagsPanel.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.hasMore = false;
      })
      .addCase(getTalentTagsPanel.fulfilled, (state, action) => {
        state.loading = false;
        updatePaginatedList({
          state,
          payload: action.payload,
          listKey: 'talentTagsList',
          selectedKey: 'talentTagsSelected',
          currentPageKey: 'currentPageTagsList',
          pageSizeKey: 'pageSizeTagsList',
          hasMoreKey: 'hasMore',
        });
      })
      .addCase(getTalentTagsPanel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // updateSelectedTalentTagsPanel
      .addCase(updateSelectedTalentTagsPanel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSelectedTalentTagsPanel.fulfilled, (state, action) => {
        state.loading = false;
        state.talentTagsSelected = action.payload?.tags_selected;
      })
      .addCase(updateSelectedTalentTagsPanel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // getTalentTagOptions
      .addCase(getTalentTagOptions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTalentTagOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.talentTagOptions = action.payload?.data;
      })
      .addCase(getTalentTagOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Cancel talent
      .addCase(cancelTalent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.cancelTalentStatus = "pending";
      })
      .addCase(cancelTalent.fulfilled, (state, action) => {
        state.loading = false;
        state.cancelTalentStatus = "fulfilled";
        state.message = action.payload.message; 
        state.isSuccess = action.payload.success; 
      })
      .addCase(cancelTalent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.cancelTalentStatus = "rejected";
      })
      // Import talent
      .addCase(importTalent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "importTalent";
        state.currentPageSuccess = 1;
        state.currentPageError = 1;
      })
      .addCase(importTalent.fulfilled, (state, action) => {
        state.loading = false;
        state.actionStatus = "fulfilled";
        state.actionName = "importTalent";
        state.resultImport = action.payload?.data ?? [];

        const importData = Array.isArray(action.payload?.data) ? action.payload.data : [];
        state.listImportSuccess = importData.slice(0, state.importPageSize);
        state.listImportError = [];
      })
      .addCase(importTalent.rejected, (state, action) => {
        state.loading = false;
        state.actionStatus = "rejected";
        state.actionName = "importTalent";

        const payload = action.payload as any;
        const importData = Array.isArray(payload?.data) ? payload.data : [];
        state.resultImport = importData;
        state.listImportSuccess = [];
        state.listImportError = importData.slice(0, state.importPageSize);
        state.error = payload?.message || (action.payload as string);
        state.message = payload?.message || (action.payload as string);
      })
      // Save import (finalize saving imported talents)
      .addCase(savingImportTalent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "savingImportTalent";
      })
      .addCase(savingImportTalent.fulfilled, (state, action) => {
        state.loading = false;
        state.actionStatus = "fulfilled";
        state.actionName = "savingImportTalent";
        state.message = action.payload?.message;
        state.isSuccess = action.payload?.success ?? true;
        // clear import buffers on success
        state.resultImport = {};
        state.listImportSuccess = [];
        state.listImportError = [];
        state.currentPageSuccess = 1;
        state.currentPageError = 1;
      })
      .addCase(savingImportTalent.rejected, (state, action) => {
        state.loading = false;
        state.actionStatus = "rejected";
        state.actionName = "savingImportTalent";
        const payload = action.payload as any;
        state.message = payload?.message || (action.payload as string);
        state.error = payload?.message || (action.payload as string);
        state.isSuccess = false;
      })

      // Approve talent bulk
      .addCase(approveTalentBulk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "approveTalentBulk";
      })
      .addCase(approveTalentBulk.fulfilled, (state, action: any) => {
        state.loading = false;
        state.actionStatus = "fulfilled";
        state.actionName = "approveTalentBulk";
        state.message = action.payload?.message;
        state.isSuccess = action.payload?.success;
        if (action.payload?.success) {
          state.approvingStatus = true;
          const bulkIds: number[] = action.payload?.approved_ids || [];
          if (bulkIds.length > 0) {
            const bulkSet = new Set(bulkIds);
            state.talentNewList = state.talentNewList.map((item: any) =>
              bulkSet.has(item.id) && item.status === "new" ? { ...item, status: "approving" } : item
            );
          }
        } else {
          state.approvingStatus = false;
        }
      })
      .addCase(approveTalentBulk.rejected, (state, action) => {
        state.loading = false;
        state.actionStatus = "rejected";
        state.actionName = "approveTalentBulk";
        state.approvingStatus = false;
        const payload = action.payload as any;
        state.message = payload?.message || (action.payload as string);
        state.error = payload?.message || (action.payload as string);
        state.isSuccess = false;
      })

      // Cancel approve talent bulk
      .addCase(cancelApproveTalentBulk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "cancelApproveTalentBulk";
      })
      .addCase(cancelApproveTalentBulk.fulfilled, (state, action: any) => {
        state.loading = false;
        state.actionStatus = "fulfilled";
        state.actionName = "cancelApproveTalentBulk";
        state.approvingStatus = false;
        state.approveBulkAbortController = null;
        state.message = action.payload?.message;
        state.isSuccess = action.payload?.success;
        if (action.payload?.success) {
          state.talentNewList = state.talentNewList.map((item: any) =>
            item.status === "approving" ? { ...item, status: "new" } : item
          );
        }
      })
      .addCase(cancelApproveTalentBulk.rejected, (state) => {
        state.loading = false;
        state.actionStatus = "rejected";
        state.actionName = "cancelApproveTalentBulk";
      })
  },
});
export const { setSelectedTalent, setEditingTalent, clearSelectedTalent, setIsPanelDetailTalentOpen,
  setSortBy, setSortOrder, setCurrentPage, setCurrentPageNewList, setOnConfirmDelete, setDeleteId,
  setFilterQuery, setCancelImport, setFile, setActionStatus, setIsOpenRegisterPanel,
  setListImportError, setListImportSuccess, setCurrentPageSuccess, setCurrentPageError, setImportPageSize, setResultImport, setIsLoadingAddUpdate, setIsLoadingImport, setIsLoadingDelete,
  setIsLoadingSendMail, setLoadingFetchTalent, setTalentSearchForm,
  setGenderOptions, setProfessionOptions, setCityOptions, setTypeOptions, setPreferredCityOptions,
  setChangeJobOptions, setStatusOptions, setRecruitmentRankOptions, setDateOptions, 
  setJobViewRecommendOptions, setJobScoutRecommendOptions, setHaveOtherConditionSearch,
  setViewedJobTitle, setScoutJobTitle, setGlobalTalentStatus, setGlobalTalentStatusDateRank,
  setGlobalSearchTalentFormData, setIsClickSearch, setTalentTagsList, setCurrentPageTagsList, setInitSearchTalentForm,
  setSearchTagResult, setReferrerTalentOptions, setSearchQuery, setCancelTalentStatus, setLoginTimeOptions, setViewJobTimeOptions, setExpectedConditionOptions, setWorkingStyleOptions, setResignationReasonOptions, setJobType1Options, setJobType2Options, setJobType3Options, setIndustry1Options, setIndustry2Options, setIndustry3Options, setTalentListPageSize, setSelectedRows, setDisplaySelectedCount, setTalentTagsSelected, setTalentRegisterPageSize, setRegisterChannelFilter, setFilterStatus, setLoading, setApprovingStatus, setApproveBulkAbortController, resetBulkApproveState, resetActionState, handleSortByHeader
} = companyTalentSlice.actions;
export default companyTalentSlice.reducer;